module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.7733/img/provider-signup/community-creators-blobs.png"